import { Link } from 'react-router-dom';

import { Skeleton } from '@/componentes/ui/skeleton';
import { useIntegrador } from '@/dados';
import { cn } from '@/lib/utils';

/* FaixaEmpresa — de quem são os números desta tela.
 *
 * Sem ela o usuário configura custo sem enxergar para qual empresa está
 * configurando. Ela é obrigatória em toda etapa do funil, e continua sendo.
 *
 * ── POR QUE DEIXOU DE SER UMA FAIXA ───────────────────────────────────────
 * Era uma célula de nata só dela, empilhada entre a trilha e o título. Três
 * blocos de mesma cor, um embaixo do outro, dizendo três coisas de peso
 * diferente: o olho chegava no conteúdo depois de atravessar duas faixas que
 * não eram o assunto. Agora ela mora DENTRO do cabeçalho da etapa, do lado
 * direito, e responde "de quem são estes números" no mesmo relance em que o
 * título responde "o que esta tela decide". Um bloco a menos, nenhuma
 * informação a menos.
 *
 * Alinhada à direita porque é CONTEXTO: quem já sabe de que empresa se trata
 * (o caso de sempre, a partir da segunda tela) não gasta nem uma fixação nela. */
export function FaixaEmpresa({ className }: { className?: string | undefined }) {
  const integrador = useIntegrador();
  const linha = integrador.data;

  if (integrador.isPending) {
    return (
      <div data-nao-imprimir="" className={cn('grid justify-items-end gap-1.5', className)}>
        <Skeleton className="h-4 w-36" />
        <Skeleton className="h-3 w-24" />
      </div>
    );
  }

  // Fora da impressão: o laudo já identifica a empresa no cabeçalho dele, e
  // "Editar" é navegação, que não existe no papel.
  return (
    <div data-nao-imprimir="" className={cn('grid min-w-0 justify-items-start gap-0.5 mesa:justify-items-end', className)}>
      <span className="rotulo">Empresa</span>
      <span className="w-full truncate text-corpo font-semibold mesa:text-right">
        {linha?.nome_empresa ?? 'Empresa sem cadastro'}
      </span>
      <span className="text-tinta-2 flex items-center gap-1.5 text-nota">
        <span className="numero truncate">{linha?.regime_tributario ?? 'Regime não informado'}</span>
        <span aria-hidden="true" className="bg-tinta-4 size-1 shrink-0 rounded-pilula" />
        <Link to="/empresa" className="text-acao shrink-0 font-semibold hover:underline">
          Editar
        </Link>
      </span>
    </div>
  );
}
